import { AnyAction, ListenerEffectAPI, ThunkDispatch } from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { getReviews } from '../components/RatingsAndReviews/thunks/get-reviews.thunk';
import { ReviewsHeaderAndPaginationFilters } from '../components/RatingsAndReviews/thunks/models/reviews-header-and-pagination-filters.model';

export const AppReviewsFiltersListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const filters: Partial<ReviewsHeaderAndPaginationFilters> =
    api.getState().reviews.filters;
  const appId = api.getState().reviews.appId;
  api.dispatch(getReviews({ appId, filters }));
};
